import script from "./bigEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./bigEvents.vue?vue&type=script&setup=true&lang=js"

import "./bigEvents.vue?vue&type=style&index=0&id=d8d00b4a&lang=less&scoped=true"

import exportComponent from "D:\\Develop\\项目\\机电集团官网\\custom-website-desk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8d00b4a"]])

export default __exports__